import * as Yup from 'yup';

export const EventValidations = () => {
  return Yup?.object()?.shape({
    name: Yup?.string()?.required('Your name is required'),
    email: Yup.string().email().required('E-mail is required'),
    phone: Yup?.string()?.required('Phone number is required'),
    inviteetype: Yup?.string()?.required('Participant type is required'),
    position: Yup?.string()?.required('Position is required'),
    city: Yup?.string()?.required('City is required'),
    state: Yup?.string()?.required('State is required'),
  });
};

export const EventInitialValues = () => {
  return {
    name: '',
    email: '',
    phone: '',
    company: '',
    inviteetype: '',
    position: '',
    city: '',
    state: '',
  };
};
